export default "__VITE_ASSET__DdKGskSf__"